import React from 'react';

function Registrations() {
  return <p className="text-center text-gray-600 py-3">No registration history!</p>;
}

export default Registrations;
